import { memo } from 'react';

import { SquareImage } from '@components/square-image';
import { useScopedTranslate } from '@locale/translate';

import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'integration';

export const Node = memo((node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);

  const integration = node.data.integration;
  const icon = integration?.thumbnail ? <SquareImage src={integration.thumbnail} /> : undefined;

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard
        node={node}
        label={integration?.name ?? t('title')}
        descriptionText={node.data?.description}
        isConfigured={node.data.isConfigured}
        icon={icon}
      >
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Integration',
  },
};
